import {message, Drawer } from "antd";
import React, { useState } from "react";
import {  BsFilterLeft } from "react-icons/bs";
import logo from '../assets/whiteOdecent.png'
import { IoMenu } from "react-icons/io5";
import { Link } from "react-router-dom";
import { BiDollar } from "react-icons/bi";
import { MdDashboard } from "react-icons/md";
import { FaCircleDollarToSlot } from "react-icons/fa6";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaUserPlus } from "react-icons/fa";
import { RiUserSearchFill } from "react-icons/ri";
import { GiOrbit } from "react-icons/gi";
import { BiSolidMessageRoundedDots } from "react-icons/bi";
import { RiFileList3Fill } from "react-icons/ri";
import AdminProfile from "../Component/AdminProfile";
import { AiFillApi } from "react-icons/ai";


const Navbar = ({ updated, initial }) => {
  const [open, setOpen] = useState(false);
  const { profile } = AdminProfile();

  const logout = () => {
    localStorage.clear();
    message.success("Logout Successfully.");
    window.location.href = "/";
    // Navigate('/')
  };

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const sidebarItems = [
    // {
    //   title: "Dashboard",
    //   path: "/dashboard",
    //   icon: <MdDashboard size={20} />,
    // },
  
    // {
    //   title: "Create user",
    //   path: "/dashboard/createusers",
    //   icon: <FaUserPlus size={20} />,
    // },

    {
      title: "Search",
      path: "/dashboard/activeuser",
      icon: <RiUserSearchFill size={20} />,
    },
    // {
    //   title: "Active Bot",
    //   path: "/dashboard/active",
    //   icon: <GoDependabot size={20} />,
    // },
    // {
    //   title: "All users",
    //   path: "/dashboard/alluser",
    //   icon: <FaUsers size={20} />,
    // },
    // {
    //   title: "Livedata",
    //   path: "/dashboard/livedata",
    //   icon: <FaDatabase size={16} />,
    // },
    {
      title: "All Api",
      path: "/dashboard/allApi",
      icon: <AiFillApi size={20} />,
    },
    {
      title: "All Bots",
      path: "/dashboard/allbots",
      icon: <AiFillApi size={20} />,
    },
    // {
    //   title: "Email Templates",
    //   path: "/dashboard/emailTemplates",
    //   icon: <AiFillWindows size={20} />,
    // },

    {
          title: "Trades",
          path: "/dashboard/alltrades",
          icon: <AiFillApi size={20} />,
        },
    {
      title: "Positions",
      path: "/dashboard/position",
      icon: <AiFillApi size={20} />,
    },
 {
      title: "API Status",
      path: "/dashboard/botlist",
      icon: <RiFileList3Fill size={20} />,
    },


    // {
    //   title: "Botlist",
    //   path: "/dashboard/botlist",
    //   icon: <RiFileList3Fill size={20} />,
    // },
    {
      title: "Errors",
      path: "/dashboard/errors",
      icon: <RiFileList3Fill size={20} />,
    },
    {
      title: "Support",
      path: "/dashboard/support",
      icon: <RiFileList3Fill size={20} />,
    },
    // {
    //   title: "Active Bot",
    //   icon: <AiFillSignal size={20} />,
    //   //  path: "/dashboard/admin",
    //   subItems: [
    //     {
    //       title: "Add API",

    //       // icon: <AiFillRedditCircle size={20} />,
    //       path: "/dashboard/",
    //     },
    //     { title: "View API", path: "/dashboard" },
    //   ],
    // },
  ];

  

  

  // const getData = () => {
  //   const token = localStorage.getItem('token')
  //   const postData = {
  //     jwt: token,
  //   }
  //   const response = axios({
  //     method: 'POST',
  //     headers: { "Content-Type": "application/json" },
  //     url: process.env.REACT_APP_API + 'logs',
  //     data: postData
  //   }).then(res => {
  //     console.log("naverror" , res)
  //   }).catch(err => {
  //       console.log( "naverror" , err)
  //       // setTimeout(() => {
  //       //   localStorage.clear();
  //       //   window.location.href = "/";
  //       //   Navigate("/");
  //       // }, 5000); 
  //       if (err?.response?.data?.Error === "Session Expired") {
  //         setTimeout(() => {
  //           localStorage.clear();
  //           window.location.href = "/";
  //           navigate("/");
  //           message.error(err?.response?.data?.Error);
  //         }, 100);
  //       }
  //     })
  // }

  // useEffect(() => {
  //   getData()
  // }, [])

  return (
    <>
      <nav>
        <div className={`p-4 hidden md:flex justify-between items-center  ml-auto ${initial ? "md:w-[calc(100%-210px)]" : "md:w-[calc(100%-75px)]"}`}>
          <div className=" flex gap-16 items-center">
            <div className="">
              <BsFilterLeft size={45}
                className={`absolute cursor-pointer top-1 w-100 mt-3  text-black rounded-full ${!initial ? "-scale-y-100 -rotate-180" : ""
                  }`}
                onClick={() => updated(!initial)} />
            </div>
            <div className=" text-lg md:text-2xl  font-medium ">Hello, {`${profile.Adminname}!`}</div>
          </div>

          <button
            className=" bg-colorAccent text-white px-6 py-2 rounded-md"
            onClick={logout}
          >
            Logout
          </button>
        </div>

        <div className="bg-white py-1 px-1 flex justify-between items-center md:hidden">
          <div className=" w-[30%] bg-colorSecondaryDark px-2 ">
            <img src={logo} alt="" className=" py-3 " />
          </div>
          {/* <div className=" text-lg md:text-2xl capitalize font-medium ">Hello, Admin!</div> */}
          <div>
            <div className="flex items-center">
              <div className="px-3"><IoMenu size={30} onClick={showDrawer} /></div>
            </div>
          </div>
        </div>
      </nav>

      <Drawer title={`Hello, ${profile.Adminname}!`} placement="right" onClose={onClose} open={open} width={250} className="akhil-darwer">
        {/* <Menu
          selectedKeys={[location?.pathname]}
          mode="vertical"
          className="w-full bg-colorPrimary p-0 h-screen"
        > */}
        <div className=" mt-4">
          <ul className=" text-black">
            {
              sidebarItems.map((item , index) => {
                return (
                  <>
                  <Link
                      key={index}
                      to={item.path}
                      onClick={() => setOpen(false)}
                      // className={`uppercase ${!isDrawerOpen && "hidden"}`}
                      className=" text-black"
                    >
                    <li className=" w-36 mx-auto bg-white top-left-shadow py-2 pl-4 flex gap-2 rounded-lg my-5 text-sm">
                      <span>{item?.icon}</span>
                      <span className=" text-xs font-semibold">{item?.title}</span>
                    </li>
                    </Link>
                  </>
                )
              })
            }
          </ul>
        </div>
        {/* </Menu> */}
      </Drawer>

    </>
  );
};

export default Navbar;
